module.exports = __webpack_public_path__ + "77623e6bd87ed4ea47304c8318bb06d4.pdf";